"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _itemClick = _interopRequireDefault(require("./options/itemClick"));

var _allowTitle = _interopRequireDefault(require("./options/allowTitle"));

var _allowSocial = _interopRequireDefault(require("./options/allowSocial"));

var _allowDescription = _interopRequireDefault(require("./options/allowDescription"));

var _allowDownload = _interopRequireDefault(require("./options/allowDownload"));

var _loveButton = _interopRequireDefault(require("./options/loveButton"));

var _imageMargin = _interopRequireDefault(require("./options/imageMargin"));

var _hoveringBehaviour = _interopRequireDefault(require("./options/hoveringBehaviour"));

var _enableInfiniteScroll = _interopRequireDefault(require("./options/enableInfiniteScroll"));

var _cubeType = _interopRequireDefault(require("./options/cubeType"));

var _cubeImages = _interopRequireDefault(require("./options/cubeImages"));

var _cubeRatio = _interopRequireDefault(require("./options/cubeRatio"));

var _oneRow = _interopRequireDefault(require("./options/oneRow"));

var _titlePlacement = _interopRequireDefault(require("./options/titlePlacement"));

var _useCustomButton = _interopRequireDefault(require("./options/useCustomButton"));

var _galleryVerticalAlign = _interopRequireDefault(require("./options/galleryVerticalAlign"));

var _galleryHorizontalAlign = _interopRequireDefault(require("./options/galleryHorizontalAlign"));

var _galleryMargin = _interopRequireDefault(require("./options/galleryMargin"));

var _isVertical = _interopRequireDefault(require("./options/isVertical"));

var _numberOfImagesPerRow = _interopRequireDefault(require("./options/numberOfImagesPerRow"));

var _numberOfImagesPerCol = _interopRequireDefault(require("./options/numberOfImagesPerCol"));

var _galleryTextAlign = _interopRequireDefault(require("./options/galleryTextAlign"));

var _videoPlay = _interopRequireDefault(require("./options/videoPlay"));

var _imageHoverAnimation = _interopRequireDefault(require("./options/imageHoverAnimation"));

var _overlayAnimation = _interopRequireDefault(require("./options/overlayAnimation"));

var _textsHorizontalPadding = _interopRequireDefault(require("./options/textsHorizontalPadding"));

var _textsVerticalPadding = _interopRequireDefault(require("./options/textsVerticalPadding"));

var _textImageSpace = _interopRequireDefault(require("./options/textImageSpace"));

var _textBoxBorderColor = _interopRequireDefault(require("./options/textBoxBorderColor"));

var _textBoxBorderRadius = _interopRequireDefault(require("./options/textBoxBorderRadius"));

var _textBoxBorderWidth = _interopRequireDefault(require("./options/textBoxBorderWidth"));

var _textBoxWidth = _interopRequireDefault(require("./options/textBoxWidth"));

var _imageInfoType = _interopRequireDefault(require("./options/imageInfoType"));

var _groupSize = _interopRequireDefault(require("./options/groupSize"));

var _collageDensity = _interopRequireDefault(require("./options/collageDensity"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  itemClick: _itemClick["default"],
  allowTitle: _allowTitle["default"],
  allowDescription: _allowDescription["default"],
  loveButton: _loveButton["default"],
  allowSocial: _allowSocial["default"],
  allowDownload: _allowDownload["default"],
  imageMargin: _imageMargin["default"],
  hoveringBehaviour: _hoveringBehaviour["default"],
  enableInfiniteScroll: _enableInfiniteScroll["default"],
  cubeType: _cubeType["default"],
  cubeImages: _cubeImages["default"],
  cubeRatio: _cubeRatio["default"],
  oneRow: _oneRow["default"],
  titlePlacement: _titlePlacement["default"],
  useCustomButton: _useCustomButton["default"],
  galleryVerticalAlign: _galleryVerticalAlign["default"],
  galleryHorizontalAlign: _galleryHorizontalAlign["default"],
  galleryMargin: _galleryMargin["default"],
  isVertical: _isVertical["default"],
  numberOfImagesPerRow: _numberOfImagesPerRow["default"],
  numberOfImagesPerCol: _numberOfImagesPerCol["default"],
  galleryTextAlign: _galleryTextAlign["default"],
  videoPlay: _videoPlay["default"],
  imageHoverAnimation: _imageHoverAnimation["default"],
  overlayAnimation: _overlayAnimation["default"],
  textsHorizontalPadding: _textsHorizontalPadding["default"],
  textsVerticalPadding: _textsVerticalPadding["default"],
  textImageSpace: _textImageSpace["default"],
  textBoxBorderColor: _textBoxBorderColor["default"],
  textBoxBorderRadius: _textBoxBorderRadius["default"],
  textBoxBorderWidth: _textBoxBorderWidth["default"],
  textBoxWidth: _textBoxWidth["default"],
  imageInfoType: _imageInfoType["default"],
  groupSize: _groupSize["default"],
  collageDensity: _collageDensity["default"]
};
exports["default"] = _default;